import React from 'react';

import { AppDialog } from './app-dialog.interface';

export const AppDialogContext = React.createContext<AppDialog>({
	showDialog: () => {},
	showError: () => {},
	showSnackbar: () => {}
});
